import { render } from "./ContactInfo.vue?vue&type=template&id=2160cb4a&scoped=true"
const script = {}

import "./ContactInfo.vue?vue&type=style&index=0&id=2160cb4a&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2160cb4a"]])

export default __exports__